import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { CSSZSickLeaveCertificate } from '../../Interfaces/CSSZ.interface';
import CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry from './CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	item: CSSZSickLeaveCertificate;
	patientId: string;
	onCreate: (jobId?: string) => void;
}

const CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryModal: React.FC<
	Props
> = props => {
	return (
		<BaseModal
			{...props}
			title='component.CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry.modalTitle'
			size={Size.LG}>
			<CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry
				item={props.item}
				patientId={props.patientId}
				onCreate={props.onCreate}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryModal;
